export const enum keyCode {
  Enter = 'Enter',
  Escape = 'Escape',
}
